export interface IAppLicenseMetadata {
    license: string;
    version: number;
    expireDate: Date;
}
